<script>
import { prepaidFormatExpiredDate, prepaidIsExpired } from "@utils/ipetbooking-prepaid";
import { memberApplicablePrepaidOptions } from "@utils/ipetbooking-options";
import { authComputed } from "@store/helpers";

export default {
  components: {
    DetailOrderItemPrepaid: () => import("./Item/DetailOrderItemPrepaid.Jtails"),
  },
  props: {
    orderItem: {
      type: Object,
      required: true
    },
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    const checkApplicablePrepaid = () => {
      const memberApplicablePrepaidOpenOptions = memberApplicablePrepaidOptions({
        type: 'open'
      });

      if(!memberApplicablePrepaidOpenOptions[0] && this.isLoggedIn) {
        this.tryToFetchApplicablePrepaidOrderList()
      }
    };

    checkApplicablePrepaid();
  },
  methods: {
    prepaidIsExpired,
    prepaidFormatExpiredDate,
    tryToFetchApplicablePrepaidOrderList() {
      this.$store.dispatch('order/fetchApplicablePrepaidOrderList')
    }
  },
}
</script>
<!-- section template -->
<template>
  <div :class="[$style.detailOrderPrepaid, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
    <div>
      <div class="text-center mb-4">
        <div class="detailOrderPrepaid__name">
          <BaseStoreTagList
            :store-list="orderItem.stores"
            class="justify-content-center"
          />
          <span class="detailOrderPrepaid__title">{{ orderItem.prepaid.title }}</span>
          <br>
          <span v-if="$globalCategoryVisible" class="fs-sm text-gray-1">{{ orderItem.prepaid.categoryTitle }} | {{ orderItem.prepaid.sizeTitle }}</span>
        </div>
        <div class="detailOrderPrepaid__meta">
          <span>使用期限：</span>
          <span>{{ prepaidFormatExpiredDate(orderItem) }}</span>
          <span v-if="prepaidIsExpired(orderItem.expiredDate)">(已過期)</span>
        </div>
      </div>
    </div>
    <DetailOrderItemPrepaid
      :order-item="orderItem"
    />
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.detailOrderPrepaid {
  :global {
    .detailOrderPrepaid {
      &__title {
        color: $color-primary;
        font-size: 1.25rem;
        margin: 1rem 0;
      }
      &__name {
        margin-bottom: 0.25rem;
        font-weight: 600;
      }

      &__meta {
        font-size: 0.875rem;
        color: $color-gray-2;
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .detailOrderPrepaid {
        &__title {

        }
      }
    }
  }
}
</style>
